'use strict';

const _=require('pulsar-utils/dist-es6/_');
const zonedMoment=require('pulsar-utils/dist-es6/time/zonedMoment');
const moment=require('pulsar-utils/dist-es6/time/moment');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const CalendarDay=require('pulsar-utils/dist-es6/time/calendarDay');

const DayInMilliseconds=8.64e7;
const DefaultTransitionDuration=380;
const TotalMonthsToDisplayInGraph=5;

const StatisticsPanelHeaderHeight=35;
const StatisticsPanelHeaderBottomBorderThickness=2;
const StatisticsPanelBodyVerticalDividingBorderThickness=1;
const StatisticsPanelWrapperBorderThickness=1;
const MinimumStatisticsPanelDimensions={
height:137,
width:281};


const YEAR_MONTH_FORMAT='YYYY-MM';let

StatisticsPanelHelpers=class StatisticsPanelHelpers{
static filterSortedIncidentsToIntervalPlusOneBefore(incidents,interval){
const filteredIncidents=[];
let finalIncidentBeforeInterval=null;

const intervalStartTime=interval.start.getTime();
const intervalEndTime=interval.end.getTime();

for(const incident of incidents){
const incidentTime=incident.time.getTime();
if(incidentTime>intervalEndTime){
break;
}
if(incidentTime>=intervalStartTime){
filteredIncidents.push(incident);
}else{
finalIncidentBeforeInterval=incident;
}
}

return{
filteredIncidents,
finalIncidentBeforeInterval};

}

static getDayDifference(laterUnixTime,earlierUnixTime){
return Math.floor((laterUnixTime-earlierUnixTime)/DayInMilliseconds);
}

static getUtcReferenceStartOfDayFor(time,timezone){
return CalendarDay.calendarDayFor({time,timezone}).startOfDayInTimezone('Etc/Utc');
}

static getUtcReferenceAxisDomainFor(interval,timezone){
_.ensureInstanceOf(TimeInterval,interval);
_.ensureInstanceOf('string',timezone);

return[interval.start,interval.end].map(t=>StatisticsPanelHelpers.getUtcReferenceStartOfDayFor(t,timezone));
}

static getUtcReferenceStartOfMonthFor(time,timezone){
_.ensureInstanceOf(Date,time);
_.ensureInstanceOf('string',timezone);

const yearAndMonth=zonedMoment(time,timezone).format(YEAR_MONTH_FORMAT);
return moment.utc(yearAndMonth,YEAR_MONTH_FORMAT).toDate();
}

static getSubComponentDimensionsFrom({height=MinimumStatisticsPanelDimensions.height,width=MinimumStatisticsPanelDimensions.width}={}){
const availableHeight=height-StatisticsPanelWrapperBorderThickness*2-StatisticsPanelHeaderBottomBorderThickness;
const availableWidth=width-StatisticsPanelWrapperBorderThickness*2-StatisticsPanelBodyVerticalDividingBorderThickness;

const panelBodyHeight=availableHeight-StatisticsPanelHeaderHeight;

return{
left:{
height:panelBodyHeight,
width:panelBodyHeight},

right:{
height:panelBodyHeight,
width:availableWidth-panelBodyHeight}};


}

static getPathStartTimeForDaysSinceGraph(lastIncidentTimeBeforeInterval,startOfDayForLastPurgedIncident,boundsStart,creationTime){
if([lastIncidentTimeBeforeInterval,startOfDayForLastPurgedIncident,boundsStart,creationTime].every(t=>!_.exists(t))){
return null;
}

if(_.exists(lastIncidentTimeBeforeInterval)||_.exists(startOfDayForLastPurgedIncident)){
return _([lastIncidentTimeBeforeInterval,startOfDayForLastPurgedIncident]).compact().maxBy(t=>t.getTime());
}

return _([boundsStart,creationTime]).compact().minBy(t=>t.getTime());
}

static getDaysSinceLastIncidentGraphViewData(dataStartTime,incidents,timezone,interval){
_.ensureInstanceOf(Array,incidents);
_.ensureInstanceOf('string',timezone);
_.ensureInstanceOf(TimeInterval,interval);

const graphXAxisDomain=StatisticsPanelHelpers.getUtcReferenceAxisDomainFor(interval,timezone);

if(!_.exists(dataStartTime)){
return{
graphViewData:[],
daysSinceMostRecentIncident:null,
graphYAxisDomain:[0,1],
graphXAxisDomain};

}

_.ensureInstanceOf(Date,dataStartTime);

const getUnixDayStartFor=time=>CalendarDay.calendarDayFor({time,timezone}).valueOf();
const reversedUTCUnixTimes=_([{time:dataStartTime},...incidents]).
map(({time})=>getUnixDayStartFor(time)).
sortedUniqBy().
concat(getUnixDayStartFor(interval.end)).
reverse().
value();

const numPoints=reversedUTCUnixTimes.length;
const reverseXYPairsPerTime=new Array(numPoints);

let previouslySeenUnixTime=reversedUTCUnixTimes[0];
let largestDayDifference=0;
for(let i=1;i<numPoints;i++){
const currentUnixTime=reversedUTCUnixTimes[i];

let dayDifference=StatisticsPanelHelpers.getDayDifference(previouslySeenUnixTime,currentUnixTime);

if(i!==1){



dayDifference--;
}

reverseXYPairsPerTime[i-1]=[
[reversedUTCUnixTimes[i-1],0],
[reversedUTCUnixTimes[i-1],dayDifference]];


if(dayDifference>largestDayDifference){
largestDayDifference=dayDifference;
}

previouslySeenUnixTime=currentUnixTime;
}

reverseXYPairsPerTime[numPoints-1]=[
[reversedUTCUnixTimes[numPoints-1],0]];


const flatReverseXYPairsPerIncident=_.flatten(reverseXYPairsPerTime);
return{
graphViewData:flatReverseXYPairsPerIncident,
daysSinceMostRecentIncident:flatReverseXYPairsPerIncident[1][1],
graphYAxisDomain:[0,largestDayDifference],
graphXAxisDomain};

}

static get MinimumStatisticsPanelDimensions(){
return MinimumStatisticsPanelDimensions;
}

static get DayInMilliseconds(){
return DayInMilliseconds;
}

static get DefaultTransitionDuration(){
return DefaultTransitionDuration;
}

static get TotalMonthsToDisplayInGraph(){
return TotalMonthsToDisplayInGraph;
}};


module.exports=StatisticsPanelHelpers;
//# sourceMappingURL=statisticsPanelHelpers.js.map
